// Scripts
import '~scripts/main';

// Styles
import 'styles/pages/emails/index.scss';

// Core
import { BREAKPOINTS } from '~scripts/core/breakpoints';

// Blocks
import Header from '~scripts/blocks/header';
import Navigation from '~scripts/blocks/navigation';
import initRequestForm from '~scripts/blocks/request-form';
import initSubscribeForm from '~scripts/blocks/subscribe-form';

// Components
import '~scripts/components/modals';
import { scrollAnimationProgress } from '~scripts/core/animations';

// Breakpoints
const mediaSm = window.matchMedia(`(max-width: ${BREAKPOINTS.smMax})`);

// Swiper
import Swiper from 'swiper';
import { Navigation as SwiperNavigation, Pagination as SwiperPagination } from 'swiper/modules';
Swiper.use([SwiperNavigation, SwiperPagination]);

//
// HEADER
//
Header();

//
// NAVIGATION
//
Navigation();

//
// FORM
//
const demoRequestForms = document.querySelectorAll('.js-demo-request-form');

demoRequestForms.forEach((form) => {
  initRequestForm(form);
});

//
// SUBSCRIBE FORM
//
const subscribeForms = document.querySelectorAll('.js-subscribe-form');

subscribeForms.forEach((form) => {
  initSubscribeForm(form);
});

// Slider
const typesEmailsSliderOptionsSm = {
  allowTouchMove: true,
  effect: 'slide',
  loop: false,
  navigation: false,
  noSwiping: false,
  slidesPerView: 'auto',
  spaceBetween: 12,
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: true,
  },
  breakpoints: {
    860: {
      spaceBetween: 20,
    },
  },
};

let typesEmailsSlider = null;

const handleTypesEmailsSliderInit = () => {
  if (typesEmailsSlider) {
    typesEmailsSlider.destroy();
  }

  typesEmailsSlider = new Swiper('#types-emails-slider', typesEmailsSliderOptionsSm);
};

const handleWindowResize = () => {
  if (window.innerWidth < 1040 && !typesEmailsSlider) {
    handleTypesEmailsSliderInit();
  } else if (window.innerWidth >= 1040 && typesEmailsSlider) {
    typesEmailsSlider.destroy();
    typesEmailsSlider = null;
  }
};

handleWindowResize(); // Вызовите функцию прямо здесь
window.addEventListener('resize', handleWindowResize);
window.addEventListener('load', handleWindowResize);

//
// EMAILS CARDS
//
// Animation
let stopEmailsCardsAnimation = [];

const handleEmailsCardsAnimation = () => {
  const emailsCards = document.querySelectorAll('.js-email-card');

  if (mediaSm.matches) {
    stopEmailsCardsAnimation.forEach((stop) => stop());
  } else {
    stopEmailsCardsAnimation = Array.from(emailsCards, (emailCard) => {
      return scrollAnimationProgress(emailCard, {
        getStart(el) {
          const rect = el.getBoundingClientRect();
          return rect.top + window.scrollY - window.innerHeight;
        },
        getEnd(el, start) {
          return start + 100;
        },
      });
    });
  }
};

handleEmailsCardsAnimation();
mediaSm.addEventListener('change', handleEmailsCardsAnimation);
